import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

/**
 * Campo de senha com o "olho" no final para ver o que foi digitado (padrão P-C, src/docs/padroes-front.md).
 * Cada campo tem o próprio olho. O rótulo do botão não usa a palavra "senha" para não colidir com a busca
 * do campo pelo rótulo (testes e leitores de tela).
 * Aceita as mesmas props do TextField.
 */
export default function CampoSenha({ InputProps, ...props }) {
  const [visivel, setVisivel] = useState(false);
  return (
    <TextField
      {...props}
      type={visivel ? 'text' : 'password'}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={visivel ? 'Ocultar o que foi digitado' : 'Mostrar o que foi digitado'}
              aria-pressed={visivel}
              onClick={() => setVisivel((v) => !v)}
              onMouseDown={(e) => e.preventDefault()}
              edge="end"
            >
              {visivel ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
